import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { FormattedMessage } from 'react-intl'
import withSource from '../../../../../hocs/source-scoll'
import {Iconfont} from "../../../../../components/icon/iconfont";

export default withSource(props => {
    useStyles(classes)
    const { icon, onClick, backgroundColor, innerRef, sensors } = props
    return <div
        ref={innerRef}
        data-position={sensors?.resource_position}
        data-type={sensors?.resource_type}
        data-content={sensors?.resource_content}
        data-title={sensors?.resourcepage_title}
        className={classes.Container}
        onClick={e => onClick(e, sensors)}
        style={{
            backgroundColor: backgroundColor
        }}>
        {
            icon && <div className={classes.Icon}>
                {icon}
            </div>
        }
        <div className={classes.Content}>
            {
                props.children
            }
        </div>
        {
            onClick && <div className={classes.Add}>
                {/*<FormattedMessage id="add" defaultMessage="Add" />{'>'}*/}
                <FormattedMessage id="add" defaultMessage="Add" /><Iconfont className={classes.Icon2}>&#xE690;</Iconfont>
            </div>
        }
    </div>
})